/** @format */
import { useRef } from "react";
import { useOktaAuth } from "@okta/okta-react";

const GROUPS = {
  INTERNAL_ADMIN: "DXP_MarketIntelligence_InternalAdmin",
  USER_ADMIN: "DXP_MarketIntelligence_UserAdmin",
};
const ROLES = {
  EDIBLE_OILS: "DXP_MarketIntelligence_ROLE_EdibleOils",
  COCOA: "DXP_MarketIntelligence_ROLE_Cocoa",
  ANIMAL_FEED: "DXP_MarketIntelligence_ROLE_AnimalFeed",
  WTG: "DXP_MarketIntelligence_ROLE_WTG",
  GRAINS: "DXP_MarketIntelligence_ROLE_Grains",
  CORN: "DXP_MarketIntelligence_ROLE_Corn",
};
let { WTG, ...rest } = ROLES;
const SYNDICATION_ROLES = [...Object.values(rest)];

const useRoles = () => {
  const { oktaAuth, authState } = useOktaAuth();
  let userInfo = useRef({
    isTokenDecoded: false,
    currentUserName: "",
    currentUserEmail: "",
    groups: [],
    isSuperAdminRole: false,
    isAdminRole: false,
    isEdibleOilsRole: false,
    isCocoaRole: false,
    isAnimalFeedRole: false,
    isWTGRole: false,
    isGrainsRole: false,
    isCornRole: false,
  });
  let decodedAccessToken = null;
  let decodedIdToken = null;

  if (userInfo.current.isTokenDecoded) {
    return userInfo.current;
  }
  if (authState && authState.accessToken && authState.idToken) {
    decodedAccessToken = oktaAuth.token.decode(authState.accessToken.accessToken);
    decodedIdToken = oktaAuth.token.decode(authState.idToken.idToken);
    userInfo.current.isTokenDecoded = true;
    userInfo.current.groups = decodedAccessToken.payload.groups;
    userInfo.current.currentUserEmail = decodedIdToken.payload.email;
    userInfo.current.currentUserName = decodedIdToken.payload.name;
    userInfo.current.isSuperAdminRole = userInfo.current.groups.includes(GROUPS.INTERNAL_ADMIN);
    userInfo.current.isAdminRole =
      !userInfo.current.isSuperAdminRole && userInfo.current.groups.includes(GROUPS.USER_ADMIN);
    userInfo.current.isEdibleOilsRole =
      userInfo.current.isAdminRole && userInfo.current.groups.includes(ROLES.EDIBLE_OILS);
    userInfo.current.isCocoaRole = userInfo.current.isAdminRole && userInfo.current.groups.includes(ROLES.COCOA);
    userInfo.current.isAnimalFeedRole =
      userInfo.current.isAdminRole && userInfo.current.groups.includes(ROLES.ANIMAL_FEED);
    userInfo.current.isWTGRole = userInfo.current.isAdminRole && userInfo.current.groups.includes(ROLES.WTG);
    userInfo.current.isGrainsRole = userInfo.current.isAdminRole && userInfo.current.groups.includes(ROLES.GRAINS);
    userInfo.current.isCornRole = userInfo.current.isAdminRole && userInfo.current.groups.includes(ROLES.CORN);
  }

  return userInfo.current;
};

export default useRoles;
export { GROUPS, ROLES, SYNDICATION_ROLES };
